"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _ms = _interopRequireDefault(require("ms"));
var _occasion = _interopRequireDefault(require("occasion"));
var _displayRefCodes = _interopRequireDefault(require("../../../core/display-ref-codes"));
var _competitionInfo = _interopRequireDefault(require("./competition-info"));
var _loginForm = _interopRequireDefault(require("../../../core/login-form"));
var _entriesList = _interopRequireDefault(require("./entries-list"));
var _waitingList = _interopRequireDefault(require("./waiting-list"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Please note this is a list of entries only, the running order may well be different.");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "A list of RTC code meanings is at the bottom of the entries page.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
class CompetitionHome extends _react.Component {
  constructor(...args) {
    super(...args);
    /**
     * Get a list of all rtc codes that are in use for the given event
     */
    _defineProperty(this, "_getRtcCodes", competitionDays => {
      const rtcCodes = [];
      competitionDays.forEach(day => {
        day.waitingList.forEach(entry => {
          entry.rtcRefs.forEach(ref => {
            if (rtcCodes.indexOf(ref) === -1) {
              rtcCodes.push(ref);
            }
          });
        });
        day.races.forEach(race => {
          race.completedEntries.forEach(entry => {
            entry.rtcRefs.forEach(ref => {
              if (rtcCodes.indexOf(ref) === -1) {
                rtcCodes.push(ref);
              }
            });
          });
        });
      });
      return rtcCodes;
    });
    _defineProperty(this, "_getTimeToCompetitionText", startDate => {
      const msToCompetition = Math.max(new Date(startDate).getTime() - Date.now(), 0);
      const timeText = msToCompetition ? ' - ' + (0, _ms.default)(msToCompetition, {
        long: true
      }) + ' to go.' : '';
      return timeText;
    });
  }
  render() {
    const competition = this.props.competition;
    const successUrl = `/year/${this.props.match.params.yearID}/competition/${this.props.match.params.competitionSlug}/enter`;
    return /*#__PURE__*/_react.default.createElement("div", null, !this.props.loaded ? null : /*#__PURE__*/_react.default.createElement(_competitionInfo.default, {
      competition: competition
    }), /*#__PURE__*/_react.default.createElement(_loginForm.default, {
      successUrl: successUrl
    }), !this.props.loaded ? null : /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: competition.displayedNotes
    }), /*#__PURE__*/_react.default.createElement("h2", null, 'Entries Accepted To Date' + (this.props.loaded ? this._getTimeToCompetitionText(competition.startDate) : '')), _ref, _ref2, !this.props.loaded ? _ref3 : /*#__PURE__*/_react.default.createElement("div", null, competition.competitionDays.map(day => /*#__PURE__*/_react.default.createElement("div", {
      key: day.id
    }, !day.races.length ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
      className: "text-info"
    }, (0, _occasion.default)(day.dayDate, 'dddd')), /*#__PURE__*/_react.default.createElement(_entriesList.default, {
      displayFreeCode: competition.displayFreeCode,
      races: day.races
    }), /*#__PURE__*/_react.default.createElement(_waitingList.default, {
      displayFreeCode: competition.displayFreeCode,
      waitingList: day.waitingList
    })))), /*#__PURE__*/_react.default.createElement(_displayRefCodes.default, {
      codeType: "rtc",
      filterCodes: this._getRtcCodes(competition.competitionDays)
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = _mergeBqlQueries({
  displayFreeCode: true,
  startDate: true,
  displayedNotes: true,
  competitionDays: {
    id: true,
    dayDate: true,
    waitingList: _mergeBqlQueries({}, _waitingList.default.partials.WaitingList),
    races: _mergeBqlQueries({
      id: true
    }, _entriesList.default.partials.Races)
  }
}, _competitionInfo.default.partials.Competition);
var _default = exports.default = (0, _reactBicycle.connect)(CompetitionHome, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref4
}), undefined, {
  renderLoading: true
});